var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Utils
import { css } from 'styled-components';
export var getDividerStylesByOrientation = function (orientation) {
    return orientation === 'horizontal'
        ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        width: inherit;\n        height: 0px;\n        border-top-width: 1px;\n      "], ["\n        width: inherit;\n        height: 0px;\n        border-top-width: 1px;\n      "]))) : css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        width: 0px;\n        height: inherit;\n        border-left-width: 1px;\n      "], ["\n        width: 0px;\n        height: inherit;\n        border-left-width: 1px;\n      "])));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=getDividerStylesByOrientation.js.map